import Service from "../../Services";

const FreePage = {
    namespaced: true,
    state: {
        content: null
    },
    mutations: {
        setContent: (state, res) => {
            state.content = res;
        },
        clearContent: state => {
            state.content = null;
        }
    },
    actions: {
        onGetFreePageData({ commit }, slug) {
            return Service.FreePageAPI.getFreePageData(slug).then(res => {
                if (res.response_code === 200) {
                    commit('setContent', res.result);
                } else {
                    commit('clearContent');
                }
            });
        }

    },
};

export default FreePage
